<template>
  <article
    class="flyer-card-skeleton overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm"
    :class="view === 'post' ? 'flyer-card-skeleton-post' : 'mb-3 break-inside-avoid'"
    aria-hidden="true"
  >
    <div class="animate-pulse">
      <div class="relative bg-slate-100" :class="view === 'post' ? 'h-[22rem]' : mediaHeightClass">
        <div class="absolute right-2 top-2 h-6 w-6 rounded-full bg-white/80 ring-1 ring-slate-200"></div>
        <div class="absolute bottom-2 left-2 h-5 w-24 rounded-full bg-white/80"></div>
      </div>

      <div class="grid gap-3 p-3.5">
        <div class="flex items-center justify-between gap-3">
          <div class="h-3 w-28 rounded-full bg-slate-200"></div>
          <div class="h-3 w-16 rounded-full bg-slate-200"></div>
        </div>

        <div class="border-t border-slate-100 pt-3">
          <div class="flex items-center gap-2">
            <div class="h-7 w-7 rounded-full bg-slate-200"></div>
            <div class="grid flex-1 gap-2">
              <div class="h-3 w-28 rounded-full bg-slate-200"></div>
              <div class="h-2.5 w-20 rounded-full bg-slate-100"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  index: { type: Number, default: 0 },
  view: { type: String, default: 'masonry' }
})

const mediaHeights = ['h-44', 'h-56', 'h-48', 'h-64', 'h-52', 'h-60']
const mediaHeightClass = computed(() => mediaHeights[props.index % mediaHeights.length])
</script>
